import { Modal, Form, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import { Button, Icon } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import ListMensagem from '../Projeto/ListMensagem';
import { ConsolidadoPluriAnual, getTotalComentarios, salvarConsolidadoPlurianualComentario } from '@app/api/aContratarComentario';

export interface PropsModalComentario {
    idLinha: string;
}

const ModalComentario = (props: PropsModalComentario) => {
    const { idLinha } = props;
    const [recarregarMensagem, setRecarregarMensagem] = useState(false);
    const [exibirModal, setExibirModal] = useState(false);
    const [iconeComentario, setIconeComentario] = useState('');
    const textAreaId = `textAreaId${idLinha}`;


    useEffect(() => {
        getTotalComentarios(idLinha).then((total) => {
            if (total && total > 0) {
                MudarIconeAnexo();
            }
        })
    }, [idLinha]);

    const MudarIconeAnexo = () => {
        setIconeComentario('has-comments');
    };

    const limparCampo = () => {
        const elemento = document.getElementById(textAreaId);
        if (elemento != null) {
            document.getElementById(textAreaId).value = '';
        }
    };

    const getAll = async () => {
        setRecarregarMensagem(!recarregarMensagem);
    };

    const showModal = () => {
        limparCampo();
        setExibirModal(true);
    };

    const handleCancel = () => {
        limparCampo();
        setExibirModal(false);
    };

    const Salvar = (e: any) => {
        const text = document.getElementById(textAreaId).value;
        const consolidadoForm = {
            consolidadoPluriAnualId: idLinha,
            mensagem: text,
        } as ConsolidadoPluriAnual;


        salvarConsolidadoPlurianualComentario(consolidadoForm).then(data => {
            if (data && data.valid) {
                limparCampo();
                setRecarregarMensagem(!recarregarMensagem);
                MudarIconeAnexo();
            }
        });
    };

    return (
        <>
            <Tooltip title="Comentários">
                <Button
                    onClick={() => {
                        getAll();
                        showModal();
                    }}
                    icon="messaging-comments"
                    className={iconeComentario}
                />
            </Tooltip>
            <Modal
                title="Comentário"
                className="chat-modal"
                visible={exibirModal}
                onCancel={() => {
                    handleCancel();
                }}
                footer={[
                    <Button key="submit" type="link" icon="messaging-send" onClick={e => Salvar(e)}>
                        Enviar
          </Button>,
                    <Button key="submit" type="primary" icon="commons-cancel" onClick={() => handleCancel()}>
                        Fechar
          </Button>,
                ]}>
                <ListMensagem
                    idLinha={idLinha}
                    recarregarMensagem={recarregarMensagem}
                />
                <div className="chat-modal-message-box">
                    <Form>
                        <Form.Item>
                            
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
};

export default ModalComentario;
